import React, { useEffect, useRef, useState } from 'react';
import { SessionHeaderItem } from './componenets/session-header-item';

import ClassIcon from '../../../../../../../assets/icons/exam/class.svg';
import studentRegistrationIcon from '../../../../../../../assets/icons/exam/student-registration.svg';

import studentSchedulingIcon from '../../../../../../../assets/icons/exam/student-scheduling.svg';

import protector from '../../../../../../../assets/icons/exam/protector.svg';
import { InputSwitch } from 'primereact/inputswitch';
import { updateSessionOpenRegistrationOperation } from './operations/update-session-open-registration-operation';
import globalProgramStore from '../../../../../../../stores/program-store';
import globalCourseStore from '../../../../../../../stores/global-course-store';
import { ExamSessionDetails } from '../../../../../../../api/types/programs/course/exams/response/exam-metadata';
import { numberToHebrewLetter } from '../../../../../../../utils/hebrew-date-utils';
import './switcher-exam-header-color.css';
import { Calendar } from 'primereact/calendar';
import { updateSessionDateOperation } from './operations/update-session-date-operation';
import { updateSessionRegistrationDatesOperation } from './operations/update-session-registration-dates-operation';

interface SessionHeaderDatamodel {
  examId: number;
  sessionNumber: number;
  examSessionDetails: ExamSessionDetails;
  setSessionDetails: (sessionDetails: ExamSessionDetails[]) => any;
}

export const SessionHeader: React.FC<SessionHeaderDatamodel> = ({
  examSessionDetails,
  examId,
  sessionNumber,
  setSessionDetails,
}) => {
  const [checked, setChecked] = useState(
    examSessionDetails?.isOpenRegistration ?? false,
  );

  useEffect(() => {
    setChecked(examSessionDetails?.isOpenRegistration ?? false);
  }, [examSessionDetails?.isOpenRegistration]);

  const handleSetCheck = async (checked: boolean) => {
    const currentProgramId = globalProgramStore.getCurrentId();
    const currentCourse = globalCourseStore.getCurrentCourse();
    await updateSessionOpenRegistrationOperation(
      currentProgramId,
      currentCourse?.metadata.id,
      examId,
      examSessionDetails.id,
      checked,
      setChecked,
      setSessionDetails,
    );
  };

  const registrationStudentNumber =
    examSessionDetails?.studentsRegistrations.filter(
      (item) => item.enrollment,
    ).length;

  const classesNumber = examSessionDetails?.classesSchedule.length;

  const protectorNumber = examSessionDetails?.classesSchedule.flatMap(
    (item) => item.protectors,
  ).length;

  const scheduleStudentsNumber = examSessionDetails?.classesSchedule.flatMap(
    (item) => item.enrollment,
  ).length;

  const handleSessionDateChange = async (date?: Date) => {
    const currentProgramId = globalProgramStore.getCurrentId();
    const currentCourse = globalCourseStore.getCurrentCourse();

    await updateSessionDateOperation(
      currentProgramId,
      currentCourse?.metadata.id,
      examId,
      examSessionDetails,
      date,
      setSessionDetails,
    );
  };

  const [updateStartRegistrationDate, setUpdateStartRegistrationDate] =
    useState<Date | undefined>();
  const handleUpdateRegistrationDates = async (
    registrationStartDate?: Date,
    registrationEndDate?: Date,
  ) => {
    const currentProgramId = globalProgramStore.getCurrentId();
    const currentCourse = globalCourseStore.getCurrentCourse();

    await updateSessionRegistrationDatesOperation(
      currentProgramId,
      currentCourse?.metadata.id,
      examId,
      examSessionDetails,
      registrationStartDate,
      registrationEndDate,
      setSessionDetails,
    );
  };

  const calendarInputRef = useRef<HTMLInputElement>(null);
  useEffect(() => {
    // When the calendar input gets focused automatically
    if (calendarInputRef.current) {
      // Immediately blur it to remove focus
      calendarInputRef.current.blur();
    }
  }, []);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        paddingTop: '16px',
        paddingBottom: '16px',
        paddingLeft: '24px',
        backgroundColor: '#f9fafb',
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          gap: '24px',
        }}
      >
        <SessionHeaderItem
          headline={'מועד'}
          content={`מועד ${numberToHebrewLetter(sessionNumber)}׳`}
          image={<i className="pi pi-calendar mr-2"></i>}
        />
        <SessionHeaderItem
          headline={`תאריך בחינה`}
          /*content={`מועד ${numberToHebrewLetter(sessionNumber)}׳`}*/
          image={
            <Calendar
              style={{
                height: '30px',
                width: '180px',
                direction: 'ltr',
                marginTop: '4px',
              }}
              inputStyle={{ textAlign: 'right' }}
              value={
                /*new Date() */ examSessionDetails?.sessionDate
                  ? new Date(examSessionDetails.sessionDate)
                  : null
              }
              onChange={(event) => handleSessionDateChange(event.value)}
              showIcon
              autoFocus={false}
              inputRef={calendarInputRef}
              dateFormat={'dd/mm/yy'}
              showOnFocus={false}
            />
          }
        />
        <SessionHeaderItem
          headline={'סטודנטים רשומים'}
          content={registrationStudentNumber}
          image={studentRegistrationIcon}
        />
        <SessionHeaderItem
          headline={'מספר כיתות'}
          content={classesNumber}
          image={ClassIcon}
        />
        <SessionHeaderItem
          headline={'מספר משגיחים'}
          content={protectorNumber}
          image={protector}
        />
        <SessionHeaderItem
          headline={'משוביצים לבחינה'}
          content={scheduleStudentsNumber}
          image={studentSchedulingIcon}
        />

        <SessionHeaderItem
          headline={'מסמכים'}
          content={examSessionDetails?.files.length.toString()}
          image={<i className="pi pi-file-o mr-2"></i>}
        />
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
        <label>זמני הרשמה</label>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            gap: '4px',
          }}
          className="switch-wrapper"
        >
          <Calendar
            style={{
              height: '30px',
              width: '180px',
              direction: 'ltr',
              marginTop: '4px',
            }}
            inputStyle={{ textAlign: 'right' }}
            maxDate={
              examSessionDetails?.sessionDate
                ? new Date(examSessionDetails.sessionDate)
                : undefined
            }
            value={
              /*new Date() */ examSessionDetails?.registrationStartDate
                ? new Date(examSessionDetails.registrationStartDate)
                : null
            }
            onChange={(event) => {
              setUpdateStartRegistrationDate(event.value);
              handleUpdateRegistrationDates(event.value, undefined);
            }}
            showIcon
            autoFocus={false}
            inputRef={calendarInputRef}
            dateFormat={'dd/mm/yy'}
            showOnFocus={false}
          />
          <label>עד</label>
          <Calendar
            style={{
              height: '30px',
              width: '180px',
              direction: 'ltr',
              marginTop: '4px',
            }}
            maxDate={
              examSessionDetails?.sessionDate
                ? new Date(examSessionDetails.sessionDate)
                : undefined
            }
            minDate={
              /*new Date() */ examSessionDetails?.registrationStartDate
                ? new Date(examSessionDetails.registrationStartDate)
                : undefined
            }
            inputStyle={{ textAlign: 'right' }}
            value={
              /*new Date() */ examSessionDetails?.registrationEndDate
                ? new Date(examSessionDetails.registrationEndDate)
                : null
            }
            onChange={(event) =>
              handleUpdateRegistrationDates(
                examSessionDetails?.registrationStartDate,
                event.value,
              )
            }
            showIcon
            autoFocus={false}
            inputRef={calendarInputRef}
            dateFormat={'dd/mm/yy'}
            showOnFocus={false}
          />
        </div>
      </div>
    </div>
  );
};
